import { render, staticRenderFns } from "./productWarehouseMgt.vue?vue&type=template&id=031e84b0&scoped=true&"
import script from "./productWarehouseMgt.vue?vue&type=script&lang=js&"
export * from "./productWarehouseMgt.vue?vue&type=script&lang=js&"
import style0 from "./productWarehouseMgt.vue?vue&type=style&index=0&id=031e84b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031e84b0",
  null
  
)

export default component.exports